import { Provider } from '@angular/core';
import { HttpAuditService } from '@daas-consulting/security/audit/frontend/data_access';
import { SecurityAuditServiceId } from '@daas-consulting/security/audit/frontend/data_contracts';

export const AuditServiceProvider: Provider = {
  provide: SecurityAuditServiceId,
  useClass: HttpAuditService,
};
